import { useEffect, useRef } from "react";
import { API, getSession } from "./api";

// Tiempo real por WebSocket + respaldo por intervalo + recarga al volver a la app o recibir un push.
export function useAutoRefresh(load, ms = 30000) {
  const loadRef = useRef(load);
  loadRef.current = load; // siempre la versión más reciente, sin reconectar

  useEffect(() => {
    let ws, retryTimer, pingTimer, debounce, retry = 0, closed = false;

    // Junta varios avisos seguidos en una sola recarga
    const run = () => {
      clearTimeout(debounce);
      debounce = setTimeout(() => loadRef.current(), 120);
    };

    const connect = () => {
      const s = getSession();
      if (!s || closed) return;
      ws = new WebSocket(`${API.replace(/^http/, "ws")}/ws?token=${encodeURIComponent(s.token)}`);
      ws.onopen = () => {
        retry = 0;
        run(); // por si cambió algo mientras estuvo desconectado
        pingTimer = setInterval(() => ws.readyState === 1 && ws.send("ping"), 25000);
      };
      ws.onmessage = (e) => { if (e.data === "refresh") run(); };
      ws.onclose = () => {
        clearInterval(pingTimer);
        if (!closed) retryTimer = setTimeout(connect, Math.min(1000 * 2 ** retry++, 10000));
      };
    };

    loadRef.current();
    connect();

    const tick = () => {
      if (document.visibilityState !== "visible") return;
      run();
      if (!ws || ws.readyState > 1) { clearTimeout(retryTimer); connect(); } // reconectar al volver
    };
    const onMsg = (e) => { if (e.data?.type === "refresh") run(); };

    const interval = setInterval(tick, ms);
    document.addEventListener("visibilitychange", tick);
    window.addEventListener("focus", tick);
    window.addEventListener("online", tick);
    navigator.serviceWorker?.addEventListener("message", onMsg);

    return () => {
      closed = true;
      clearInterval(interval); clearInterval(pingTimer);
      clearTimeout(retryTimer); clearTimeout(debounce);
      ws?.close();
      document.removeEventListener("visibilitychange", tick);
      window.removeEventListener("focus", tick);
      window.removeEventListener("online", tick);
      navigator.serviceWorker?.removeEventListener("message", onMsg);
    };
  }, [ms]);
}